export default {
  computed: {
    $typeAheadCallTypes() {
      return [
        { uid: 1,
          value: "appt",
          text: "Patient Appointments",
          description: "Scheduling medical appointments for patients."
        },
        { uid: 2,
          value: "coordination",
          text: "Care Coordination Calls",
          description: "Managing patient care plans and services."
        },
        { uid: 3,
          value: "records_request",
          text: "Medical Records Requests",
          description:" Inquiries regarding patient health records."
        },
        { uid: 4,
          value: "refills",
          text: "Prescription Refills",
          description:"Requesting medication renewals for patients."
        },
        { uid: 5,
          value: "insurance_verification",
          text: "Insurance Verification",
          description:" Checking coverage and claims information."
        },
        { uid: 6,
          value: "home_healthcare",
          text: "Home Healthcare Services",
          description:"Arranging caregiving services at home."
        },
        { uid: 7,
          value: "equip_orders",
          text: "Medical Equipment Orders",
          description:"Procuring necessary medical devices."
        },
        { uid: 8,
          value: "referral_coord",
          text: "Referral Coordination",
          description:"Referring patients to specialists or clinics."
        },
        { uid: 9,
          value: "billing_insurance",
          text: "Billing and Insurance Inquiries",
          description:" Handling payment-related questions."
        },
        { uid: 10,
          value: "med_adherence",
          text: "Medication Adherence Calls",
          description:"Monitoring patient medication compliance."
        },
        { uid: 11,
          value: "lab_followup",
          text: "Follow-Up on Lab Results",
          description:"Discussing test findings with patients."
        },
        { uid: 12,
          value: "emerg_assistance",
          text: "Emergency Assistance Calls",
          description:"Responding to urgent medical situations."
        },
        { uid: 13,
          value: "tele_consult",
          text: "Telehealth Consultations",
          description:"Arranging virtual medical appointments."
        },
        { uid: 14,
          value: "home_visit_sched",
          text: "Home Visits Scheduling",
          description:"Planning caregiver visits to patients."
        },
        { uid: 15,
          value: "health_ed",
          text: "Health Education Calls",
          description:"Providing information on medical conditions."
        },
        { uid: 16,
          value: "hospice_coord",
          text: "Hospice Care Coordination",
          description:"Supporting end-of-life care needs."
        },
        { uid: 17,
          value: "diet_consult",
          text: "Dietary Consultations",
          description:"Arranging consultations with nutritionists."
        },
        { uid: 18,
          value: "physical_therapy",
          text: "Physical Therapy Sessions",
          description:"Scheduling rehabilitation appointments."
        },
        { uid: 19,
          value: "durable_medical",
          text: "Durable Medical Equipment",
          description: "Ordering and delivering equipment."
        },
        { uid: 20,
          value: "caregiver_train",
          text: "Caregiver Training",
          description:"Organizing caregiver education sessions."
        },
        { uid: 21,
          value: "home_mod_req",
          text: "Home Modification Requests",
          description:"Adapting homes for patient needs."
        },
        { uid: 22,
          value: "med_sup_ord",
          text: " Medical Supplies Orders",
          description:"Procuring necessary medical supplies."
        },
        { uid: 23,
          value: "social_serv_coord",
          text: "Social Services Coordination",
          description:"Accessing social support resources."
        },
        { uid: 24,
          value: "home_safety_assess",
          text: "Home Safety Assessments",
          description:"Evaluating patient living environments."
        },
        { uid: 25,
          value: "presc_del",
          text: "Prescription Delivery",
          description:"Arranging medication delivery to patients' homes"
        }
      ];
    }
  }
};
